module.exports = "<pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> * <span class=hljs-keyword>as</span> Dialog <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-dialog'</span>\n\n<span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n  <span class=hljs-comment>// ...</span>\n  directives: {\n    <span class=hljs-string>'dialog'</span>: Dialog.directive\n  },\n  components: {\n    <span class=hljs-string>'wv-dialog'</span>: Dialog.component\n  },\n  <span class=hljs-comment>// ...</span>\n}\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/installation-commonjs-alternative.md
 ** module id = 115
 ** module chunks = 1
 **/